var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_doc_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139169",
    "data-name": "\\uD328\\uC2A4 139169",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139170",
    "data-name": "\\uD328\\uC2A4 139170",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.985 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139171",
    "data-name": "\\uD328\\uC2A4 139171",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.914.914,0,0,1,.269.269.9.9,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.805 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139172",
    "data-name": "\\uD328\\uC2A4 139172",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.985 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139173",
    "data-name": "\\uD328\\uC2A4 139173",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.985 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139174",
    "data-name": "\\uD328\\uC2A4 139174",
    d: "M47.815,4.232H2.116A2.116,2.116,0,0,1,0,2.116H0A2.116,2.116,0,0,1,2.116,0h45.7a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,47.815,4.232Z",
    transform: "translate(16.388 31.261)",
    fill: "#5e9cf7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139175",
    "data-name": "\\uD328\\uC2A4 139175",
    d: "M47.815,4.232H2.116A2.116,2.116,0,0,1,0,2.116H0A2.116,2.116,0,0,1,2.116,0h45.7a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,47.815,4.232Z",
    transform: "translate(16.388 44.096)",
    fill: "#2266d3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139176",
    "data-name": "\\uD328\\uC2A4 139176",
    d: "M47.815,4.232H2.116A2.116,2.116,0,0,1,0,2.116H0A2.116,2.116,0,0,1,2.116,0h45.7a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,47.815,4.232Z",
    transform: "translate(16.388 56.931)",
    fill: "#5e9cf7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139177",
    "data-name": "\\uD328\\uC2A4 139177",
    d: "M47.815,4.232H2.116A2.116,2.116,0,0,1,0,2.116H0A2.116,2.116,0,0,1,2.116,0h45.7a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,47.815,4.232Z",
    transform: "translate(16.388 69.767)",
    fill: "#2266d3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139178",
    "data-name": "\\uD328\\uC2A4 139178",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139179",
    "data-name": "\\uD328\\uC2A4 139179",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#5e9cf7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139378",
    "data-name": "\\uD328\\uC2A4 139378",
    d: "M0,10.6V.214H3.245A8.45,8.45,0,0,1,6.684.779,4.359,4.359,0,0,1,8.63,2.515a5.486,5.486,0,0,1,.713,2.9A5.382,5.382,0,0,1,8.6,8.224a4.4,4.4,0,0,1-1.981,1.809,8.206,8.206,0,0,1-3.349.565ZM2.274,1.847V8.965H3.39q3.576,0,3.576-3.569,0-3.549-3.576-3.549Zm13.433,8.972a4.858,4.858,0,0,1-3.724-1.444,5.556,5.556,0,0,1-1.354-3.959,5.594,5.594,0,0,1,1.347-3.972A4.853,4.853,0,0,1,15.707,0a4.861,4.861,0,0,1,3.731,1.447,5.579,5.579,0,0,1,1.354,3.969,5.579,5.579,0,0,1-1.347,3.952A4.85,4.85,0,0,1,15.707,10.818Zm.007-9.178a2.32,2.32,0,0,0-1.964.985,4.617,4.617,0,0,0-.73,2.791,4.588,4.588,0,0,0,.73,2.78,2.443,2.443,0,0,0,3.921-.007,4.607,4.607,0,0,0,.73-2.78,4.62,4.62,0,0,0-.727-2.784A2.311,2.311,0,0,0,15.714,1.64ZM30.773,9.9a10.052,10.052,0,0,1-2.081.751A7.72,7.72,0,0,1,27.2,10.8a4.977,4.977,0,0,1-3.755-1.419,5.466,5.466,0,0,1-1.371-3.962,5.492,5.492,0,0,1,1.388-3.952A4.928,4.928,0,0,1,27.211.014a7.83,7.83,0,0,1,3.562.875V3.018h-.241A4.86,4.86,0,0,0,27.466,1.64a2.677,2.677,0,0,0-2.191.989,4.325,4.325,0,0,0-.806,2.8,4.193,4.193,0,0,0,.82,2.773,2.718,2.718,0,0,0,2.191.975,4.014,4.014,0,0,0,1.4-.252,5.874,5.874,0,0,0,1.674-1.12h.22Z",
    transform: "translate(7.088 8.772)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaDocIcon);
export default __webpack_public_path__ + "static/media/minerva_doc_icon.deaeba24dc56be4b7d921f72c6a25d8a.svg";
export { ForwardRef as ReactComponent };